/*
 * @Author: Dong
 * @Date: 2022-05-05 16:14:17
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-03-16 15:34:28
 */
import React, { useState, forwardRef } from 'react';
import { useIntl } from 'react-intl';
import { Button, Row, Col, Form, Input } from 'sup-ui';
import { FormComponentProps } from 'sup-ui/lib/form';
import Modal from 'root/components/CommonModal';
import { updateNanotubeDataApi } from 'root/services/nanotube';

import alone from 'root/assets/images/standalone@2x.png';
import colony from 'root/assets/images/illustrator_colony@2x.png';
import messages from '../messages';
import styles from '../index.less';
import { useDispatch } from 'react-redux';
import { common } from 'root/store/actions';

interface PropsType extends FormComponentProps {
  getEnvList?: () => {};
}

const AddEnv = forwardRef((props: PropsType) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const { form, getEnvList } = props;
  const { getFieldDecorator, setFieldsValue, getFieldValue } = form;

  const [visible, setVisible] = useState(false);

  // 添加运行环境
  const onOk = () => {
    form.validateFields((err, values) => {
      if (err) return;

      const { envName, deployment } = values;
      const params = {
        deployMode: deployment === 'alone' ? 0 : 1,
        createTime: new Date().getTime(),
        envName,
      };

      updateNanotubeDataApi(params).then(() => {
        if (getEnvList) {
          getEnvList();
        } else {
          dispatch(common.updateEnv({ hasEnv: true }));
        }
        toggleVisable();
      });
    });
  };

  // 选择环境类型
  const changeEnv = (type: string) => {
    setFieldsValue({ deployment: type });
  };

  // 模态框显隐
  const toggleVisable = () => {
    setVisible(!visible);
  };

  // 渲染表单内容
  const renderForm = () => {
    return (
      <Form labelCol={{ span: 24 }} wrapperCol={{ span: 24 }} className={styles.envForm}>
        <Form.Item label={intl.formatMessage(messages.envName)} colon={false}>
          {getFieldDecorator('envName', {
            rules: [
              {
                required: true,
                message: intl.formatMessage(messages.nameNull),
              },
              {
                message: intl.formatMessage(messages.nameError),
                pattern: new RegExp(/^[\u4e00-\u9fa5a-zA-Z0-9]+$/),
              },
            ],
          })(<Input autoComplete="off" maxLength="64" />)}
        </Form.Item>

        <Form.Item label={intl.formatMessage(messages.selectEnvType)} colon={false}>
          {getFieldDecorator('deployment', {
            rules: [
              {
                required: true,
                message: intl.formatMessage(messages.selectEnvType),
              },
            ],
          })(
            <div className={styles.select_env}>
              <Row>
                <Col
                  span={7}
                  className={`${styles.nanotube} ${getFieldValue('deployment') === 'alone' ? styles.active : ''}`}
                  onClick={() => changeEnv('alone')}
                >
                  <img src={alone} />
                  <div className={styles.titleFont}>{intl.formatMessage(messages.alone)}</div>
                </Col>
                <Col
                  span={7}
                  className={`${styles.nanotube} ${getFieldValue('deployment') === 'colony' ? styles.active : ''}`}
                  onClick={() => changeEnv('colony')}
                >
                  <img src={colony} />
                  <div className={styles.titleFont}>{intl.formatMessage(messages.colony)}</div>
                </Col>
              </Row>
            </div>,
          )}
        </Form.Item>
      </Form>
    );
  };

  return (
    <>
      <Button type="primary" className={styles.btn} onClick={toggleVisable}>
        {intl.formatMessage(messages.addEnv)}
      </Button>
      <Modal
        onCancel={toggleVisable}
        onOk={onOk}
        className={styles.envModal}
        height="auto"
        width="552px"
        visible={visible}
        title={intl.formatMessage(messages.addEnv)}
      >
        {renderForm()}
      </Modal>
    </>
  );
});

export default Form.create()(AddEnv);
